<template>
  <div class="container">
    <Header></Header>
    <headerSearch></headerSearch>
    <mainTab :nindex="3"></mainTab>
    <section class="brand_show_wrap w1440">
      <!-- <img :src="item.image_text" v-for="(item,index) in banner" :key="index" @click="jump(item.url)" class="top_img" /> -->
      <swiper
          :pagination="{ clickable: true }"
          :autoplay="{ delay: 3000, disableOnInteraction: false }"
          @swiper="onSwiper"
          class="home_swiper"
          :observer="true"
          :observeParents="true"
          :modules="modules"
          loop
          ref="swiper"
        >
          <swiper-slide class="swiper_item" v-for="(item, index) in banner" :key="index">
            <a @click="jump(item.url)" class="top_banner cu flex flex-center flex-col" :style="{ backgroundImage: `url(${item.image_text})` }"> </a>
          </swiper-slide>
        </swiper>


      <section class="select_wrap1 fs16">
        <div class="select_box">
          <div class="flex-box select_row">
            <p class="type">筛选项</p>
            <div class="selected_item flex-box" v-if="tabIndex >= 0">
              <p class="key">类别：{{ categoryList[tabIndex]?.name }}</p>
              <div class="value flex-box">
                <i class="icon_del" @click="clearAll"></i>
              </div>
            </div>
            <div class="selected_item flex-box" v-if="current >= 0">
              <p class="key">种类：{{ categoryList[tabIndex]?.children[current]?.name }}</p>
              <div class="value flex-box">
                <i class="icon_del" @click="secondCategoryClick(-1)"></i>
              </div>
            </div>
          </div>
          <div class="flex-box flex-col-start select_row">
            <p class="type mt10">分类</p>
            <ul class="flex-box flex-wrap flex-grow-1">
              <li
                class="type_value"
                :class="tabIndex == index ? 'active' : ' '"
                v-for="(item, index) in categoryList"
                :key="index"
                @click="categoryClick(index)"
              >
                {{ item.name }}
              </li>
            </ul>
          </div>
          <div class="flex-box flex-col-start select_row">
            <p class="type mt10">种类</p>
            <ul class="flex-box flex-wrap flex-grow-1">
              <li class="type_value" :class="current == -1 ? 'active ' : ''" @click="secondCategoryClick(-1)">全部</li>
              <li
                class="type_value"
                v-for="(item, index) in categoryList[tabIndex]?.children"
                :key="index"
                @click="secondCategoryClick(index)"
                :class="current == index ? 'active' : ''"
              >
                {{ item.name }}
              </li>
            </ul>
          </div>
        </div>
      </section>

      <div class="flex-box flex-wrap brand_list">
        <router-link
          class="brand_item"
          target="_blank"
          :to="'/brandshowdetail?id=' + item.id"
          v-for="(item, index) in brandList"
          :key="index"
        >
          <div class="img_logo flex-box flex-center">
            <img :src="item.image_text" />
          </div>
          <div class="name m-ellipsis fs16">{{ item.name }}</div>
        </router-link>
      </div>
      <div v-if="brandList.length == 0" class="nodata fs16 tc">
        <img src="@/assets/static/icon/c_notitle.png" class="c_nodata" alt="" />
        <p>暂无相关数据</p>
      </div>
      <div
        v-if="brandList.length != 0 && currentData.current_page < currentData.last_page"
        class="flex-box flex-center flex-col-start more"
        @click="getMoreBrand"
      >
        <div class="fs20">点击查看更多</div>
        <img src="@/assets/static/icon/z_icon_more1.png" class="icon_down" />
      </div>
    </section>
  </div>
</template>
<script>
import { useHead } from "@unhead/vue";
import { ref, onMounted } from "vue";
import { Navigation, Scrollbar, Autoplay, EffectFade, Parallax, FreeMode,Pagination } from "swiper";
import { Swiper, SwiperSlide } from "../../../node_modules/swiper/vue/swiper-vue";
import "swiper/swiper.min.css";
import "swiper/swiper-bundle.min.css";
export default {
  data() {
    return {
      letterIndex: 0,
      categoryList: [],
      cateIndex: -1,
      q: "",
      currentData: null,

      tabIndex: -1, //商品上部分类
      current: -2,
      query: {
        first_category_id: 0,
        category_id: 0,
      },
      banner:[],
      brandList: [],
      page: 1,
    };
  },
  created() {
    this.goodsCategory();
     this.getBanner();
  },
  methods: {
    // 获取分类
    goodsCategory() {
      this.$api.GetCategoryList().then((res) => {
        if (res.code == 1) {
          this.categoryList = res.data;
          // this.categoryClick(0);
          this.refresh();
        }
      });
    },
    // 获取轮播
    getBanner() {
      let that = this;
      that.$api.GetBanner({ group: "pc_brand" }).then((res) => {
        that.banner = res.data.pc_brand;
      });
    },
    jump(url){
				if(url){
					window.open(url, "_blank");
				}
				
			},
    categoryClick(index) {
      this.tabIndex = index;
      this.current = -1;
      this.query.first_category_id = this.categoryList[index].id;
      this.query.category_id = 0;
      this.refresh();
    },
    //二级分类
    secondCategoryClick(index) {
      this.current = index;
      let id = 0;
      if (index > -1) {
        id = this.categoryList[this.tabIndex].children[index].id;
      }
      this.query.category_id = id;
      this.refresh();
    },
    refresh() {
      this.brandList = [];
      this.page = 1;
      this.fetch();
    },
    fetch() {
      let that = this;
      let query = this.query;
      query.list_rows = 20;
      that.$api
        .GetBrandList(query)
        .then((res) => {
          if (res.code == 1) {
            this.brandList = this.brandList.concat(res.data.data);
            this.currentData = res.data;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getMoreBrand() {
      this.page = this.page + 1;
      this.fetch();
    },
    clearAll() {
      this.tabIndex = -1;
      this.current = -2;
      let query = {
        first_category_id: 0,
        category_id: 0,
      };
      this.query = query;
      this.refresh();
    },
  },
  setup() {
    onMounted(() => {
      useHead({
        title: "优选品牌-小狮优选",
        meta: [
          { name: "description", content: "This is my page description" },
          { property: "og:title", content: "My Page Title" },
          { property: "og:description", content: "This is my page description" },
          { property: "og:url", content: "https://example.com/my-page" },
          { property: "og:image", content: "https://example.com/my-image.jpg" },
        ],
        link: [{ rel: "canonical", href: "https://example.com/my-page" }],
      });
    });

    // const modules = [Navigation, Scrollbar, Autoplay, EffectFade, Parallax, FreeMode];
    let banner = ref([require("../../assets/static/images/z_img1.png")]);
    let swi = ref("");
    const onSwiper = (e) => {
      swi.value = e;
    };
    return {
      onSwiper,
      banner,
      modules: [Navigation, Pagination, Scrollbar, Autoplay, EffectFade, Parallax, FreeMode],
    };
  },
  components: {
    Swiper,
    SwiperSlide,
  },
};
</script>
<style lang="less" scoped>
.select_wrap1 {
  margin: 20px auto 0;
  .select_box {
    padding: 20px 30px;
    background: #ffffff;

    .type {
      width: 100px;
      color: #909090;
      line-height: 32px;
    }

    .selected_item {
      margin: 0 45px 0 0;
      padding: 0 20px;
      height: 46px;
      border-radius: 8px;
      background: #3d7efe;

      .value {
        font-weight: 700;
        line-height: 32px;

        .icon_del {
          margin-left: 13px;
          display: block;
          width: 22px;
          height: 22px;
          background-image: url(@/assets/static/icon/z_icon_delete2.png);
          background-size: 22px;
          background-repeat: no-repeat;
          cursor: pointer;
        }

        div {
          color: #fff;
        }
      }

      .value + .value {
        margin-left: 10px;
      }

      .key {
        color: #ffffff;
        line-height: 32px;
      }
    }

    .type_value {
      margin: 10px 40px 0 0;
      padding: 0 5px;
      color: #040404;
      line-height: 32px;
      cursor: pointer;
    }

    .type_value.active {
      color: #3d7efe;
    }
  }
}

.brand_show_wrap {
  // padding-bottom: 60px;
  padding-bottom: 0.2rem;

  .top_img {
    margin: 0 auto;
    display: block;
    // width: 1440px;
  }
  .more {
    padding: 6px 0 0;
    line-height: 28px;
    cursor: pointer;
    div {
      // color: #6b6b6b;
      color: #3d7efe;
    }
    .icon_down {
      margin-left: 10px;
      display: block;
      width: 18px;
      height: 18px;
    }
  }
}

.home_swiper {
  margin: 0 auto;
  width: 100%;
  height: 400px;
  position: relative;
  z-index: 1;

  .swiper_item {
   height: 400px;
  }

  .top_banner {
    width: 100%;
    height: 100%;
    background-position: center;
    background-repeat: no-repeat;
    background-size: 100%;
  }
}

.letters_box {
  padding: 0 26px;
  margin: 32px auto;
  // width: 1440px;
  height: 50px;
  background: #ffffff;
  .icon_scroll {
    margin-right: 30px;
    display: block;
    width: 22px;
    height: 22px;
    cursor: pointer;
  }
  .letter_item {
    color: #040404;
    line-height: 36px;
    cursor: pointer;
  }
  .letter_item.active {
    color: #3d7efe;
  }
}
.area_tab_row {
  margin: 0 auto 56px;
  // width: 1440px;
  height: 60px;
  background: #efefef;
  border-radius: 20px;
  .tab {
    padding: 0 40px;
    // width: 480px;
    width: 33%;
    height: 70px;
    text-align: center;
    border-radius: 20px;
    font-size: 30px;
    color: #464444;
    line-height: 50px;
    letter-spacing: 1px;
    font-style: normal;
    cursor: pointer;
    .text {
      height: 40px;
      margin-top: -5px;
    }
  }
  .tab.active {
    position: relative;
    color: #3d7efe;
    .text {
      border-left: 4px solid #3d7efe;
      border-right: 4px solid #3d7efe;
      z-index: 3;
    }
  }
  .tab.active::after {
    position: absolute;
    top: 0;
    left: 50%;
    content: "";
    transform: translateX(-50%);
    width: 480px;
    height: 74px;
    background-image: url(@/assets/static/icon/z_icon_selected.png);
    background-repeat: no-repeat;
    background-size: 480px 74px;
    background-position: center;
    z-index: 2;
    filter: drop-shadow(0px 2px 14px rgba(160, 162, 165, 0.4));
  }
}

.brand_list {
  margin: 20px auto 0;
  .brand_item {
    margin: 0 20px 24px 0;
    display: block;
    // width: 220px;
    width: calc((100% - 100px) / 6);
    height: 279px;
    background: #ffffff;
    border-radius: 12px;
    overflow: hidden;
    .img_logo {
      margin: 10px auto;
      max-width: 100%;
      height: 201px;
      border-radius: 12px 12px 0px 0px;
      img {
        display: block;
        max-width: 100%;
      }
    }
    .name {
      padding: 0 10px;
      width: 100%;
      height: 58px;
      // background: #efefef;
      border-radius: 0px 0px 12px 12px;
      color: #4b4b4b;
      line-height: 58px;
      text-align: center;
      font-style: normal;
    }
  }
  .brand_item:nth-of-type(6n) {
    margin: 0 0 24px;
  }
  .brand_item:hover {
    margin-top: -10px;
    box-shadow: 0px 2px 14px 0px rgba(160, 162, 165, 0.4);
    .name {
      background: #3d7efe;
      color: #fff;
    }
  }
}

@media screen and (max-width: 1440px) {
  .home_swiper {
    height: 355px;

    .swiper_item {
      height: 355px;
    }
  }
}
</style>
